function isString(possibleString) {
  return (typeof possibleString === 'string' || possibleString instanceof String);
}

module.exports.isStringAndIsInBounds = function(variable, lowerBound, upperBound) {
  return isString(variable) && variable.length >= lowerBound && variable.length <= upperBound;
}
